const configuration = {
  digitalOceanSpaces: process.env.REACT_APP_DIGITALOCEANSPACES,
  bucketName: process.env.REACT_APP_BUCKETNAME,
};

export default configuration;
